module.exports = __webpack_public_path__ + "static/media/colliers360-logo-200.29733c2a.png";